import classNames from "classnames";
import styles from "./style.module.scss";

interface ConfirmationDialogProps {
  title: string;
  bodyText: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationDialog = ({
  title,
  bodyText,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
}: ConfirmationDialogProps) => {
  return (
    <div className={styles.dialog} data-testid="confirmation-dialog">
      <div className={styles.title}>{title}</div>
      <div className={styles.bodyText}>{bodyText}</div>
      <div className={styles.buttonGroup}>
        <button
          onClick={onCancel}
          className={classNames([styles.button, styles.cancelButton])}
        >
          {cancelText}
        </button>
        <button
          onClick={onConfirm}
          className={classNames([styles.button, styles.confirmButton])}
        >
          {confirmText}
        </button>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
